import axios from '@core_utils/api/_axios.js'
import i18n from '@/i18n'

const payment = {
    namespaced: true,
    state:{
        requestItem: {
            peirod: null,
            company_id: null,
            company_name: null,
            company_code: null,
            user_id: null,
            user_name: null,
            e_mail: null,
            password: null,
            tel_office: null,
            by_qe: null,
            lang: 'ko',
            vendor_code: null
        },

        isPaymentSuccess: false,
        isRequestSuccess: false,

        isRequestFree: false,
        isRequestProcessing: false,

        supplier: {
            author: '배익현',
            supplier_number: '349-86-01679',
            company_name: '(주)퀀티파이드이에스지',
            company_address: '서울시 종로구 새문안로3길 12(신문로빌딩), 3층',
            business_type: '정보통신업',
            phone: '02-6956-2416',
        },

        // static state 자체사용, 수정하지 마시오
        service_names: [
            {name: '전문가 컨설팅', code: 'consulting'},                
            {name: 'ESG 레벨업', code: 'level_up'},
            {name: '정보공개 지원', code: 'disclosure'},
            {name: '평가 후속 서비스', code: 'assessment_result'},
            {name: 'ESG 평가', code: 'assessment'},
        ],
        payed_item: {},
        assessment_service: {
            title: 'ESG 평가 1회 참여권',
            title_e: 'Basic',
            description: 'ESG 평가 1회 참여 수수료입니다. 온라인 평가 플랫폼을 통한 답변 제출 및 전문가 평가가 진행되며, 기본 결과보고서를 받아보실 수 있습니다.',
            price: 500000,
            promotion_price: 300000,
            available_period: ''
        },
        //static state 자체사용, 수정하지 마시오
        service_detail_list: [
            {
                title: '일반 평가',
                title_e: 'Basic',
                description: '',
                price: '-',
                promotion_price: '-',
                available_period: '',
                services: [
                    {
                        name: '전문가 컨설팅',
                        code: 'consulting',
                        provide: 'X',
                        contents: []
                    },
                    {
                        name: 'ESG 레벨업',
                        code: 'level_up',
                        provide: 'X',
                        contents: []
                    },
                    {
                        name: '정보공개 지원',
                        code: 'disclosure',
                        provide: 'X',
                        contents: []
                    },
                    {
                        name: '평가 후속 서비스',
                        code: 'assessment_result',
                        provide: '기본 결과보고서 제공',
                        contents: ['ESG 평가 요약 결과보고서 (웹, PDF)', 'ESG 성과관리 대시보드 이용', '개선계획 관리 및 모니터링']
                    },
                    {
                        name: 'ESG 평가',
                        code: 'assessment',
                        provide: 'X',
                        contents: []
                    }
                ]
            },
            {
                title: '프리미엄 서비스',
                title_e: 'Premium Service',
                description: '컨설팅 솔루션을 활용하여 ESG 성과를 개선하고 역량을 강화할 수 있습니다.',
                services: [
                    {
                        name: '전문가 컨설팅',
                        code: 'consulting',
                        provide: '평가결과 1:1 상세 피드백 및 핵심 개선사항 제시 (온라인)',
                        contents: ['QESG 컨설턴트와 1:1 화상회의를 통해 평가 결과 피드백','핵심 개선사항을 도출하여 향후 성과 향상을 이끌어 낼 수 있는 Quick-Consulting 프로그램']
                    },
                    {
                        name: 'ESG 가이던스 제공',
                        code: 'guidance',
                        provide: 'ESG 수준 향상에 필요한 참고자료로, 샘플 서식 및 템플릿, 우수사례집 활용',
                        contents: ['ESG 실천 가이드 백서, 샘플 서식, ESG 우수사례집 등 총 100여 종의 자료 제공']
                    },
                    {
                        name: '평가 데이터 연계 서비스',
                        code: 'esg-data',
                        provide: '데이터 엑셀 다운로드 제공, 상세 결과 종합 패키지 제공',
                        contents: ['ESG 평가 확인서, 스코어 카드 (웹 & PDF) 제공', '(2023. 12월 예정) 데이터 관리 시트 (엑셀) 제공' ]
                    },
                ]
            },
        ],
        selected_items:[],

        paymentPeriod:'',
        isValidPayment: false,
        is_premium: false,
        basic_not_paid: false,
        cart_addable: {},
        total_price: 0,
        total_original_price: 0
    },
    getters: {
        GETTER_IS_PREMIUM (state) {
            return state.is_premium !== null
                ? state.is_premium
                : JSON.parse(localStorage.getItem('is_premium')) !== null
                    ? JSON.parse(localStorage.getItem('is_premium'))
                    : false
        }
    },
    mutations: {
        update_selected_items(state, new_list) {
            state.selected_items = new_list
        },
        update_payed_item(state, new_obj) {
            state.payed_item = new_obj
        },
        update_is_premium(state, flag) {
            state.is_premium = flag
        },

        update_basic_not_paid(state, flag) {
            state.basic_not_paid = flag
        },
        update_total_price(state, price_num) {
            state.total_price = price_num
        },
        update_cart_addable(state, flag) {
            state.cart_addable = flag
        },
        update_total_original_price(state, price_num){
            state.total_original_price = price_num
        },
        update_requestItem(state, requestItem) {
            state.requestItem = {
                ...state.requestItem,
                ...requestItem
            }
        },
        update_isRequestFree(state, isRequestFree) {
            state.isRequestFree = isRequestFree
        },
        update_isRequestProcessing(state, isRequestProcessing){
            state.isRequestProcessing = isRequestProcessing
        },
        update_isRequestSuccess(state, isRequestSuccess) {
            state.isRequestSuccess = isRequestSuccess
        },
        update_isPaymentSuccess(state, isPaymentSuccess) {
            state.isPaymentSuccess = isPaymentSuccess
        },
        update_isValidPayment(state, isValidPayment) {
            state.isValidPayment = isValidPayment
        },
        update_companyId(state, companyId) {
            state.requestItem.company_id = companyId
        },
        update_userId(state, userId) {
            state.requestItem.user_id = userId
        },
        update_paymentPeriod(state, paymentPeriod) {
            state.paymentPeriod = paymentPeriod
        }
    },
    actions:{
        async checkIsPurchased  ({ commit }, company_id) {
            const response = await axios.get('/payment/company/'+company_id+'/type/purchased')
            if (response.status === 200) {
                commit('update_cart_addable', response.data)
                commit('update_paymentPeriod',response.data.period)

                if (response.data.type1.status === 'ready') {
                    commit('update_basic_not_paid', true)
                }

                if (['paid', 'ready'].includes(response.data.type1.status)) {
                    commit('update_isValidPayment', true)
                }
                
                if (response.data.type2.status === 'paid') {
                    commit('update_is_premium', true)
                }
            } else {
                console.log(response.data.msg)
            }
        },
        async requestAssessment ({commit}, requestItem) {
            const response = await axios.post('/register/request', requestItem)
            if (response.data.code === 'success') {
                commit('update_isRequestSuccess', true)
                commit('update_userId', response.data.user_id)
                commit('update_companyId', response.data.company_id)

                return true
            } else if (response.data.code === 'email_failure') {
                alert(i18n.t(`QESG 메일 수신이 불가능한 이메일 주소입니다. \n다른 메일 주소로 다시 신청해주세요.`))
            } else {
                alert(response.data.msg)
            }
            
            return false
        }
    }
}

export default payment